module.exports = __webpack_public_path__ + "static/media/odex_logo_white.49631a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/odex_logo_white.png
// module id = 1081
// module chunks = 0